/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';
import SlideInContent from './SlideInContent';

class Footer extends React.Component {
  constructor(props) {
    super();
    this.state = {

    };
    this.toggleAbout = this.toggleAbout.bind(this);
    this.backtotop = this.backtotop.bind(this);
  }
  toggleAbout() {
    this.setState({ aboutPanel: !this.state.aboutPanel });
  }
  backtotop(){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (
      <div id="Footer" className="Footer py-2">
        <div className="container-fluid ">
          <div className="row">
            <div className="col position-relative">
              <div className="position-absolute" style={{top:'-45px', right:'30px'}}>
                  <a onClick={this.backtotop} className="btn btn-link"><img src="./images/backtotop.png" /></a>
              </div>
             
            </div>
          </div>
          <div className="row p-3 p-md-5 text-light" style={{ backgroundColor: '#262626' }}>
            <div className="col-md-3 mb-3 mb-md-0">
              <div className="mb-5 text-center text-md-left">
                <h6 className="font-weight-bold mb-4">CONTACT US</h6>
                <p className="mb-1 font-weight-bold">Youth Corps Singapore</p>
                <p className="mb-1">490 Lor 6 Toa Payoh #04-10 Singapore 310490</p>
              </div>
              <div className="text-center text-md-left">
                <h6 className="font-weight-bold mb-4">VISIT US AT:</h6>
                <p className="mb-1">The Red Box 113 Somerset Road Singapore 238165</p>
                <p className="mb-1">Tel (65) 6908 2500</p>
                <p className="mb-1">Fax : (65) 6397 7860</p>
                <p className="mb-1">youth_corps_enquiries@nyc.gov.sg</p>
              </div>

            </div>
            <div className="col-md-3 text-center text-md-left">
              <ul className="list-unstyled">
                <li><h6 className="font-weight-bold mb-3 cursor_pointer" onClick={this.toggleAbout}>ABOUT YEP</h6></li>
                <li><Link to="/stories"><h6 className="font-weight-bold mb-3 cursor_pointer text-light">OUR STORIES</h6></Link></li>
                <li><Link to="/challenge"><h6 className="font-weight-bold mb-3 cursor_pointer text-light">CHALLENGE</h6></Link></li>
                <li><Link to="/customlayout"><h6 className="font-weight-bold mb-3 cursor_pointer text-light">SUBMIT STORY</h6></Link></li>
              </ul>
            </div>

            <div className="col-md-3 mb-5 mb-md-0 text-center text-md-left">
              <ul className="list-unstyled">
                {/* <li><h6 className="font-weight-bold mb-3">STORIES</h6></li> */}
                <li><Link to={'/challenge'}><h6 className="font-weight-bold mb-3 text-light">FAQS</h6></Link></li>
                <li><a href="#" target="_blank"><h6 className="font-weight-bold mb-3 text-light">JOIN US</h6></a></li>
                <li><h6 className="font-weight-bold mb-3">CONNECT WITH US</h6></li>
              </ul>
              <ul className="list-group list-group-horizontal list-unstyled d-flex justify-content-md-start justify-content-center">
                <li className="mr-2"><a className="cursor_pointer" href="https://www.facebook.com/youthcorpssg" target="_blank"><img src="./images/fb.png" /></a></li>
                <li className="mr-2"><a className="cursor_pointer" href="https://www.instagram.com/youthcorpssg/" target="_blank"><img src="./images/ig.png" /></a></li>
                <li className="mr-2"><a className="cursor_pointer" href="https://www.youtube.com/playlist?list=PLN5TkIcY0FRtiMA6HK6tFREb21GSRhQZp" target="_blank"><img src="./images/youtube_up.png" /></a></li>
              </ul>
            </div>
            <div className="col-md-3">
              <div className="d-flex justify-content-md-start justify-content-center">
                <img src="./images/nyc_logo2.png" />
              </div>
              <div className="text-center text-md-left">
                <a className="btn btn-danger mt-3" href="#" target="_blank">JOIN US</a>
              </div>
            </div>
          </div>
          <div className="row bg-dark p-3 px-md-5 py-md-2">
            <div className="col-md-6 text-light mb-2 mb-md-0 text-center text-md-left">
              <a className="text-light" href="https://tech.gov.sg/report_vulnerability">Report Vulnerability</a>&nbsp;
      |         <a className="text-light" href="#">Privacy Policy</a>&nbsp;
      |         <a className="text-light" href="#">Terms of Use</a>
              <div> © 2018 Copyright National Youth Council</div>
            </div>
            <div className="col-md-6 text-light d-md-flex justify-content-end">
              <div className="text-center text-md-left">
                Last Modified:2017-10-16<br />
                Site best viewed using I.E
              </div>
            </div>
          </div>
        </div>
        <SlideInContent hideShow={this.state.aboutPanel} parentMethod={this.toggleAbout} />
      </div>
    );
  }
}
export default Footer;
